import { type } from "jquery";
import store from "../../store/index";
import axios from "axios";

export default {
  name: "ChangescheduleStatusPopup",
  props: {
    changeStatus: { type: Object },
    statusType: {
      type: String,
      default: "",
    },
    selectedFormId: {
      type: String,
      default: "",
    },
    selectedScheduleId: {
      type: String,
      default: "",
    },
    selectedSiteId: {
      type: String,
      default: "",
    },
    selectedSubId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      idToken: "",
      headerValues: "",
      baseapi: process.env.VUE_APP_Service_URL,
      baseUrl: `${process.env.VUE_APP_Service_URL}/management/patientschedule/`,
      statusesList: [],
      loadingBlock: false,
    };
  },
  async mounted() {
    console.log("id ", this.selectedFormId, this.changeStatus);
    this.idToken = store.getters.getIdToken;
    this.headerValues = {
      headers: {
        Authorization: "Bearer " + this.idToken,
        "Content-Type": "application/json",
      },
    };
    await this.listScheduleStatuses();
  },
  methods: {
    async closeChangeScheduleModal() {
      this.$emit("closeModal");
    },
    async listScheduleStatuses() {
      await axios
        .get(
          `${this.baseapi}/management/statusmaster/getall?StatusType=${this.statusType == "Visit"
            ? "Visit"
            : this.statusType === "Site"
              ? "Site"
              : this.statusType === "Subject"
                ? "Subject"
                : "Form"
          }`,
          this.headerValues
        )
        .then((res) => {
          this.statusesList = res.data;
        })
        .catch((err) => console.log("error getting schedule statuses"));
    },
    // async changeScheduleStatus(){
    //     this.loadingBlock=true
    //     if (!this.changeStatus.visitstatus) {
    //         this.loadingBlock=false
    //       alert(this.$t('navigations.please select a status'))
    //       return;
    //     }
    //     else{
    //         if(this.statusType=='Visit')
    //         {
    //             await axios.put(`${this.baseUrl}updatevisitstatus`, this.changeStatus, this.headerValues
    //             ).then((res) => {
    //                 this.loadingBlock=false
    //                 console.log("Updated schedule status")
    //                 alert("Status updated successfully")
    //                 this.$emit("changeStatus")
    //                 this.$emit("closeModal")
    //             }).catch( err => {console.log("error updating schedule sttus", err)
    //                 this.loadingBlock=false
    //             });
    //         }
    //         else{
    //             await axios.put(`${this.baseUrl}updatescheduleformstatus`, {
    //                 "scheduleId":this.selectedScheduleId,
    //                 "formId": this.selectedFormId,
    //                 "formStatus": this.changeStatus.visitstatus
    //               }, this.headerValues
    //             ).then((res) => {
    //                 this.loadingBlock=false
    //                 console.log("Updated schedule status")
    //                 alert("Status updated successfully")
    //                 this.$emit("changeStatus")
    //                 this.$emit("closeModal")
    //             }).catch( err => {console.log("error updating schedule sttus", err)
    //                 this.loadingBlock=false
    //             });
    //         }

    //     }

    // },
    async changeScheduleStatus() {
      this.loadingBlock = true;
      if (!this.changeStatus.visitstatus) {
        this.loadingBlock = false;
        alert(this.$t("navigations.please select a status"));
        return;
      } else {
        try {
          if (this.statusType == "Visit") {
            await axios.put(
              `${this.baseUrl}updatevisitstatus`,
              this.changeStatus,
              this.headerValues
            );
          } else if (this.statusType == "Form") {
            await axios.put(
              `${this.baseUrl}updatescheduleformstatus`,
              {
                scheduleId: this.selectedScheduleId,
                formId: this.selectedFormId,
                formStatus: this.changeStatus.visitstatus,
              },
              this.headerValues
            );
          } else if (this.statusType == "Site") {
            await axios.put(
              `${this.baseapi}/management/site/changesitestatus?siteId=` +
              this.selectedSiteId +
              `&status=` +
              this.changeStatus.visitstatus,
              {},
              this.headerValues
            );
          } else if (this.statusType == "Subject") {
            await axios.put(
              `${this.baseapi}/management/patient/updatesubjectstatus`,

              {
                subjectId: this.selectedSubId,
                status: this.changeStatus.visitstatus,
              },
              this.headerValues
            );
          }

          this.loadingBlock = false;
          alert("Status updated successfully");
          this.$emit("changeStatus");
          this.$emit("closeModal");
        } catch (err) {
          console.log("error updating status", err);
          this.loadingBlock = false;
        }
      }
    },

    closemodal() {
      this.$emit("closeModal");
    },
  },
};
